module.exports = __webpack_public_path__ + "static/media/logo.19f8ec22.svg";